const useScrollableActions = (containerId: string, scrollInc: number) => {
	const hasMore = ref({
		left: false,
		right: false,
	});
	const scrollLeft = ref(0);
	const transitioning = ref(false);

	const calculateHasMore = () => {
		const container = document.getElementById(containerId);

		transitioning.value = true;
		if (container) {
			if (scrollLeft.value > 0) hasMore.value.left = true;
			else hasMore.value.left = false;
			if (container.scrollWidth - scrollLeft.value - container.clientWidth > 0) hasMore.value.right = true;
			else hasMore.value.right = false;
		}
		setTimeout(() => {
			transitioning.value = false;
		}, 250);
	};

	const forceUpdate = () => {
		if (!transitioning.value && typeof document !== "undefined") {
			const container = document.getElementById(containerId);
			scrollLeft.value = container?.scrollLeft || 0;
			calculateHasMore();
		}
	};

	onMounted(() => {
		forceUpdate();
	});

	onUpdated(() => {
		forceUpdate();
	});

	const scroll = (direction: "left" | "right") => {
		const container = document.getElementById(containerId);
		if (direction === "right") {
			container?.scroll({ left: container.scrollLeft + scrollInc, behavior: "smooth" });
			scrollLeft.value = (container?.scrollLeft || 0) + scrollInc;
			calculateHasMore();
		} else {
			container?.scroll({ left: container.scrollLeft - scrollInc, behavior: "smooth" });
			scrollLeft.value = (container?.scrollLeft || 0) - scrollInc;
			calculateHasMore();
		}
	};

	return {
		scroll,
		hasMore,
		forceUpdate,
	};
};

export default useScrollableActions;
